<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Change History Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Change History" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read prep task'">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col>
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr />

                <b-tr>
                  <b-th class="text-nowrap">
                    Name
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.name }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Description
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.description }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Result Type
                  </b-th>
                  <b-td class="w-100">
                    {{ _.startCase(_.toLower(prep_task.result_type)) }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Inspecific Scheduling
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.inspecific_scheduling ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Required
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.required ? 'True' : 'False' }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">
                    Group
                  </b-th>
                  <b-td class="w-100">
                    {{ prep_task.group ? 'True' : 'False' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>

        <div v-for="(item, index) in activity.models" :key="index">
          <div class="d-flex">
            <h3>
              {{ item.updated_at | moment('YYYY-MM-DD HH:mm:ss') }}
            </h3>
          </div>

          <b-card no-body class="bg-light">
            <div>
              <pre class="mb-0">{{ item.properties }}</pre>
            </div>
          </b-card>
        </div>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import { getCollection, getModel } from '@/shared/fetch-utils'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

export default {
  name: "WorkflowPrepTaskAuditTrailHistory",
  components: {
    PermissionAlertGate,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      prep_task: null,
      prep_task_id: this.$route.params.prep_task_id || null,
      sample_type_id: this.$route.params.sample_type_id || null,
      prep_process_id: this.$route.params.prep_process_id || null,
      activity: null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/${this.prep_task_id}/audit-trail`,
            title: "Back to Audit Trail",
            variant: "success",
          },
          {
            icon: "fa-eye",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/${this.prep_task_id}`,
            title: "View Prep Task",
            variant: "info",
          }
        ]
      }
    },
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  async created () {
    this.loading = true

    this.prep_task = await getModel({
      model_type: 'prep_task',
      id: this.prep_task_id,
      message: this.$bvToast,
    })

    this.activity = await getCollection({
      collection_type: 'activity',
      message: this.$bvToast,
      filters: [
        {
          logic: "filterEquals",
          field: "subject_type",
          value: "PrepTask"
        },
        {
          logic: "filterEquals",
          field: "subject_id",
          value: this.prep_task_id
        },
      ],
      sort: [
        {
          logic: "sortAddDesc",
          field: "created_at",
        },
      ],
    })

    this.loading = false;
  },
}
</script>
